import type { ApolloCache } from '@apollo/client'

/** Lists and aggregates cannot be updated by normalizing an attempt alone. */
export function invalidateStudentActivity(cache: ApolloCache) {
  for (const fieldName of ['myAssignedPractices', 'myAttempts', 'myHistory', 'myProgress']) {
    cache.evict({ id: 'ROOT_QUERY', fieldName })
  }
}
